// Runtime configuration reader.
//
// A config value resolves in this order:
//   1. Runtime injection — `window.__APP_CONFIG__`, written to dist/config.js by
//      server.mjs at container startup from the container's non-empty VITE_* env vars.
//   2. Build-time baked value — `import.meta.env`, set via Docker build-args when the
//      bundle was compiled (and from the .env file during local `npm run dev`).
//   3. The caller's own default.
//
// This lets a single image be retargeted per environment at runtime while still working
// with no runtime vars set (it falls back to whatever was baked into the bundle).
//
// The `typeof window` guard also matters at build time: vite-ssg pre-renders every route
// in Node, where `window` does not exist.
export function readEnv(key: keyof ImportMetaEnv): string | undefined {
  const runtime =
    typeof window !== 'undefined' && window.__APP_CONFIG__ ? window.__APP_CONFIG__ : undefined

  return runtime?.[key] ?? (import.meta.env[key] as string | undefined)
}
